import { Component, DestroyRef, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UntypedFormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ProjectStage } from '@shared/enums/project-stage.enum';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'timeline-projects-filter',
  templateUrl: './projects-timeline-filter.component.html',
  styleUrls: ['./projects-timeline-filter.component.scss']
})
export class ProjectsTimelineFilterComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private readonly t = inject(TranslateService);

  filter = new UntypedFormControl(null);

  @Output() onFilterChange: EventEmitter<any> = new EventEmitter<any>();

  stages = Object.entries(ProjectStage).map(([key, value]) => ({
    id: value,
    name: this.t.instant(`Projects.Stage.${value}`)
  }));

  get selectedTypes(): ProjectStage[] {
    return this.filter.value;
  }

  ngOnInit(): void {
    this.filter.valueChanges
      .pipe(tap((stages) => this.onFilterChange.emit(stages), takeUntilDestroyed(this.destroyRef)))
      .subscribe();
  }
}
